module.exports = __webpack_public_path__ + "static/img/coupon-model-bg.b68e91f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon-model-bg.png
// module id = FWiY
// module chunks = 0